import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';
import { boldClass } from '../styles/DefinitionSubspaceSharedStyles';

export function highlightSearchTextCellFormatter(searchText: string): React.Factory<any> {
    return React.createFactory((props: BodyCell.Props):JSX.Element => {
        if (searchText === '') { return props.value; }
        return props.value
          .split(RegExp('(' + searchText + ')', 'gi'))
          .map((fragment: string, index: number) => (
            <React.Fragment key={index}>
              {
                (fragment.toLowerCase() === searchText.toLowerCase()) ?
                <span className={boldClass}>{fragment}</span>: fragment
              }
            </React.Fragment>));
    });
}
